import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Input, Spin, Row, Col } from 'antd';
import { captchaConfig } from '../../utils/constants';
import Captcha from '../../components/Captcha.tsx';
import s from './style.m.less';
import { rules, regular } from 'grt-tool-lib-front';
import { LoadingOutlined } from '@ant-design/icons';

const { registerRule, checkIsMobile, checkRequired } = rules;

@inject('store')
@observer
class CodeVerify extends Component {
    constructor(props) {
        super(props);
        this.myForm = React.createRef();
        this.state = {
            captcha: {
                remoteUrl: captchaConfig.host,
                captchaId: captchaConfig.captchaId,
                onSuccess: this.captchaSuccess.bind(this)
            },
            smsCanClick: false,
            codeMessage: '获取验证码',
            yuyinShow: false,
            loading: false
        };
    }

    /**
     * 行为验证码验证成功回调
     * @param result
     */
    async captchaSuccess(result) {
        const {
            store: { login }
        } = this.props;

        login.setCaptchaVisible(false);
        const mobile = this.myForm.current.getFieldValue('mobile'),
            succcess = await login.getSmn({
                mobile,
                captcha_token: result.token,
                biz_type: 1, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请
                types: 1 //1短信2语音
            });

        if (succcess) {
            this.countDown(60);
        }
    }

    onFinish = (values) => {
        const {
            store: { login }
        } = this.props;

        login.codeVerifyLogin(values, this.props.type);
    };

    yuyinSms = () => {
        const {
            store: { login }
        } = this.props;

        this.myForm.current.validateFields(['mobile']).then((values) => {
            login.getSmn({
                mobile: values.mobile,
                biz_type: 1, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请
                types: 2 //1短信2语音
            });
        });
    };

    sendSmn = () => {
        const {
            store: { login }
        } = this.props;

        if (this.state.smsCanClick) {
            this.setState({ loading: true }, () => {
                this.myForm.current.validateFields(['mobile']).then(async (values) => {
                    const succcess = await login.getSmn({
                        mobile: values.mobile,
                        biz_type: 1, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请
                        types: 1 //1短信2语音
                    });

                    if (succcess) {
                        this.countDown(60);
                    }
                });
            });
        }
    };

    onValuesChange = () => {
        this.myForm.current
            .validateFields(['mobile'])
            .then(() => {
                this.setState({ smsCanClick: true });
            })
            .catch(({ errorFields }) => {
                if (errorFields.length) {
                    this.setState({ smsCanClick: false });
                }
            });
    };

    /**
     * 验证码读秒
     * @param time
     */
    countDown(time = 60) {
        const timeout = setTimeout(() => {
            if (time === 1) {
                clearTimeout(timeout);
                this.onValuesChange();
                this.setState({
                    codeMessage: '重新获取',
                    smsCanClick: true
                });
            } else {
                time--;
                this.setState({
                    codeMessage: `${time} s`,
                    // yuyinShow: time < 45,
                    smsCanClick: false,
                    loading: false
                });
                this.countDown(time);
            }
        }, 1000);
    }

    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <>
                <h3 style={{ margin: '36px 0 12px', fontSize: '24px', lineHeight: '24px' }}>手机验证码验证</h3>
                <p style={{ margin: '6px 0 36px', fontSize: '16px', color: '#666666' }}>为了您的账号安全，请完成以下验证</p>
                <div className={s.verify_logo}></div>
                <Captcha {...this.state.captcha} show={login.captchaVisible} />
                <Form ref={this.myForm} onFinish={this.onFinish} name="smsLogin" validateTrigger="onBlur" onValuesChange={this.onValuesChange}>
                    <Form.Item name="mobile" rules={[checkRequired('请填写手机号'), registerRule(checkIsMobile, '手机号格式错误')]}>
                        <Input placeholder="请输入手机号" />
                    </Form.Item>
                    <Form.Item
                        name="captcha"
                        validateTrigger="onChange"
                        rules={[
                            checkRequired('请输入验证码'),
                            () => ({
                                validator: (_, value) => {
                                    if (!value) {
                                        return Promise.resolve();
                                    }
                                    if (value.length !== 6) {
                                        return Promise.reject('验证码格式错误');
                                    }
                                    if (!regular.isNum.test(value)) {
                                        return Promise.reject('验证码格式错误');
                                    }
                                    return Promise.resolve();
                                }
                            })
                        ]}
                        extra={
                            this.state.yuyinShow ? (
                                <div
                                    style={{
                                        textAlign: 'right',
                                        lineHeight: '24px',
                                        fontSize: '12px'
                                    }}
                                >
                                    收不到验证码？<a onClick={this.yuyinSms}>尝试语音验证码</a>
                                </div>
                            ) : null
                        }
                    >
                        <Input
                            placeholder="验证码"
                            suffix={
                                <Spin spinning={this.state.loading} indicator={<LoadingOutlined spin />} size="small">
                                    <span onClick={this.sendSmn} className={!this.state.smsCanClick ? s.disabled : s.abled}>
                                        {this.state.codeMessage}
                                    </span>
                                </Spin>
                            }
                        />
                    </Form.Item>
                    <a> &nbsp;</a>
                    <Form.Item
                        help={
                            <div
                                style={{
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    color: 'rgba(0,0,0,0.25)',
                                    marginTop: '10px'
                                }}
                            >
                                <div>
                                    登录即代表您已经阅读并同意
                                    <a
                                        onClick={() => {
                                            window.open('/privacy_pc');
                                        }}
                                    >
                                        《隐私政策》
                                    </a>
                                    <a
                                        onClick={() => {
                                            window.open('/protocol');
                                        }}
                                    >
                                        《服务协议》
                                    </a>
                                </div>
                                {login.registeredStatus ? <div>未注册学员在登录成功后可注册成为学员</div> : null}
                            </div>
                        }
                    >
                        <Row style={{ marginTop: '64px' }} gutter={16}>
                            <Col span={8}>
                                <Button
                                    block
                                    onClick={() => {
                                        login.setMode('login');
                                    }}
                                >
                                    取消
                                </Button>
                            </Col>
                            <Col span={16}>
                                <Button type="primary" htmlType="submit" block>
                                    登录
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </>
        );
    }
}

export default CodeVerify;
